import { HTMLAttributes } from 'react'

import { ArticleContentItem } from './articleContentItem'
import { FormattedPostItemContent } from './articleContents'
import { ArticleContentTitle } from './articleContentTitle'

export type Props = {
  contents: FormattedPostItemContent[]
  isShowAll?: boolean
  isShowAllPremium?: boolean
  onReadMoreClick?: () => void
  articleFontSize?: string | null
  articleId: string
  openAskDoctor?: (e: boolean) => void
  adUnitPath?: string
  title?: string
  articleLink?: string
  isReadMoreBlock?: boolean
  customTargetings?: { [key: string]: (string | number) | (string | number)[] }
} & HTMLAttributes<HTMLDivElement>
export const ArticleContentBlock = ({
  contents,
  isShowAll,
  isShowAllPremium,
  onReadMoreClick,
  articleFontSize,
  articleId,
  openAskDoctor,
  adUnitPath,
  title,
  articleLink,
  isReadMoreBlock,
  customTargetings,
  ...rest
}: Props) => {
  return (
    <div className="unique-content-wrapper">
      {!!title && (
        <ArticleContentTitle
          articleId={articleId}
          title={title}
          articleFontSize={articleFontSize}
        />
      )}
      {contents.map((content, _index) => {
        if (!content) return null
        return (
          <ArticleContentItem
            key={_index}
            content={content}
            isShowAll={isShowAll}
            isShowAllPremium={isShowAllPremium}
            onReadMoreClick={onReadMoreClick}
            articleFontSize={articleFontSize}
            articleId={articleId}
            openAskDoctor={openAskDoctor}
            adUnitPath={adUnitPath}
            articleLink={articleLink}
            isHidden={isReadMoreBlock && !isShowAll && !content.isReadMore}
            customTargetings={customTargetings}
            {...rest}
          />
        )
      })}
    </div>
  )
}
